export var UIElement;
(function (UIElement) {
    UIElement["toggleMuteIcon"] = "toggleMuteIcon";
    UIElement["bubbleTitle"] = "bubbleTitle";
    UIElement["bubble_SubTitle"] = "bubble_SubTitle";
    UIElement["bubbleTitleSuffix"] = "bubbleTitleSuffix";
    UIElement["thumbnailImage"] = "thumbnailImage";
    UIElement["bubbleSubTitleSuffix"] = "bubbleSubTitleSuffix";
    UIElement["timeSincePublished"] = "timeSincePublished";
    UIElement["likeContainer"] = "likeContainer";
    UIElement["shareContainer"] = "shareContainer";
    UIElement["meatballsIcon"] = "meatballsIcon";
    //sponsored = 'sponsored',
    //followCreator = 'followCreator',
})(UIElement || (UIElement = {}));
//# sourceMappingURL=UIElement.js.map